import { getDefaultTerm, getDefaultMileage, getDefaultDeposit } from './../../../../used-vue/api/finance/GetDefaults';
import cleansePositiveNumber from '../../../../modules/cleansePositiveNumber';
import closestMatch from '../../../../modules/arrayClosestMatch';
import { saveToStorage } from '../../../../used-vue/api/Storage';

export default class {
    constructor() {
        this.customerRef = '';
        this.term = window.defaultTerm || getDefaultTerm();
        this.deposit = window.defaultDeposit || getDefaultDeposit();
        this.mileage = getDefaultMileage();
        this.postcode = '';
        this.age = '';
    }

    setTerm(desiredTerm = 36) {
        this.term = cleansePositiveNumber(desiredTerm);
        saveToStorage('new_term', this.term);
        return this.term;
    }

    getTerm(financeKeyObject) {
        let possibleTerms = financeKeyObject.getAllowedTerms();
        if (possibleTerms === false) {
            return this.term;
        }
        return closestMatch(this.term, possibleTerms);
    }

    setDeposit(desiredDeposit) {
        this.deposit = cleansePositiveNumber(desiredDeposit);
        saveToStorage('new_deposit', this.deposit);
        return this.deposit;
    }

    getDeposit(financeKeyObject) {
        let allowedDeposits = financeKeyObject.getAllowedDeposit();
        if (this.deposit < allowedDeposits.min) {
            return allowedDeposits.min;
        }
        if (this.deposit > allowedDeposits.max) {
            return allowedDeposits.max;
        }
        return this.deposit;
    }

    setMileage(desiredMileage) {
        this.mileage = cleansePositiveNumber(desiredMileage);
        saveToStorage('new_mileage', this.mileage);
        return this.mileage;
    }

    getMileage(financeKeyObject) {
        let possibleMileages = financeKeyObject.getAllowedMileages();
        if (possibleMileages.length == 0) {
            return 10000;
        }
        return closestMatch(this.mileage, possibleMileages);
    }

    setPostcode(desiredPostcode) {
        let pattern = /^([A-Za-z][0-9][ ]*[0-9][A-Za-z][A-Za-z])|([A-Za-z][0-9][0-9][ ]*[0-9][A-Za-z][A-Za-z])|([A-Za-z][A-Za-z][0-9][ ]*[0-9][A-Za-z][A-Za-z])|([A-Za-z][A-Za-z][0-9][0-9][ ]*[0-9][A-Za-z][A-Za-z])|([A-Za-z][0-9][A-Za-z][ ]*[0-9][A-Za-z][A-Za-z])|([A-Za-z][A-Za-z][0-9][A-Za-z][ ]*[0-9][A-Za-z][A-Za-z])$/
        if (pattern.test(desiredPostcode)) {
            this.postcode = desiredPostcode;
            saveToStorage('new_postcode', this.postcode);
            return this.postcode;
        }
        this.postcode = desiredPostcode.replace(/[^a-zA-Z0-9]/g, " ");
        saveToStorage('new_postcode', this.postcode);
        return this.postcode;
    }

    getPostcode() {
        return this.postcode;
    }

    setAge(desiredAge) {
        this.age = cleansePositiveNumber(desiredAge);
        saveToStorage('new_age', this.age);
        return this.age;
    }

    getAge() {
        return this.age;
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/details/finance/customer-parameters-object.js